<div class="dialog-header">
  <div class="header-content">
    <div class="header-icon">
      <mat-icon>{{ isDoc ? 'task_alt' : 'description' }}</mat-icon>
    </div>
    <div class="header-text">
      <h2 mat-dialog-title>
        {{ (isDoc ? 'createDoc.createDocDialog.title' : 'createDoc.technicalDocDialog.title') | transloco }}
      </h2>
      <p class="header-subtitle">
        {{ (isDoc ? 'createDoc.createDocDialog.subtitle' : 'createDoc.technicalDocDialog.subtitle') | transloco }}
      </p>
    </div>
  </div>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="form">
  <mat-dialog-content>
    <ng-container *ngIf="!isDoc">
      <label class="field-label">
        {{ 'createDoc.technicalDocDialog.profileLabel' | transloco }}
      </label>
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-select formControlName="tdProfileId">
          <mat-select-trigger>
            {{ selectedTdProfile ? selectedTdProfile.profileName : ('createDoc.createDocDialog.docProfileNone' | transloco) }}
          </mat-select-trigger>
          <mat-option [value]="noTdProfileId">{{ 'createDoc.createDocDialog.docProfileNone' | transloco }}</mat-option>
          <mat-option *ngFor="let profile of tdProfiles" [value]="profile.id">
            {{ profile.profileName }}
            <span *ngIf="getLinkedUnitProfileName(profile)" class="linked-profile">
              {{ 'createDoc.technicalDocDialog.linkedUnitProfile' | transloco: { name: getLinkedUnitProfileName(profile) } }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="selectedLinkedUnitProfileName" class="linked-profile-hint">
        {{ 'createDoc.technicalDocDialog.linkedUnitProfile' | transloco: { name: selectedLinkedUnitProfileName } }}
      </div>
      <div class="info-hint">
        <mat-icon color="primary" inline>info</mat-icon>
        <span>
          {{ 'createDoc.technicalDocDialog.profileHintPre' | transloco }}
          <a (click)="clickPpwrProfiles()">
            {{ 'createDoc.technicalDocDialog.profileHintLink' | transloco }}
          </a>
          {{ 'createDoc.technicalDocDialog.profileHintPost' | transloco }}
        </span>
      </div>
    </ng-container>

    <div class="language-row">
      <label class="language-label">
        {{ (isDoc ? 'createDoc.createDocDialog.languageLabel' : 'createDoc.technicalDocDialog.languageLabel') | transloco }}
      </label>
      <mat-form-field appearance="outline" class="language-select" subscriptSizing="dynamic">
        <mat-select formControlName="languageCode">
          <mat-select-trigger>
            <span class="flag-icon flag-icon-{{ form.value.languageCode }} space-right"></span>
            {{ 'language.' + form.value.languageCode | transloco }}
          </mat-select-trigger>
          <mat-option *ngFor="let code of countryCodes" [value]="code">
            <span class="flag-icon flag-icon-{{ code }} space-right"></span>
            {{ 'language.' + code | transloco }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onCreate()">
      {{ (isDoc ? 'createDoc.createDocDialog.createButton' : 'createDoc.technicalDocDialog.createButton') | transloco }}
    </button>
  </mat-dialog-actions>
</form>
